(function () {
    pagination(false);
})();

(function () {
    if (!document.body.classList.contains('post-template')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const image = cover.querySelector('.gh-cover-image');

    window.addEventListener('load', function () {
        cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        cover.classList.remove('loading');
    });
})();


(function(){
    let referrer = document.referrer;
    let historyBack = true;
    if(referrer == '' || referrer == undefined){
        historyBack = false;
    }
    let btnPrevPage = document.querySelector(".prev-page");
    if(btnPrevPage != null){
        btnPrevPage.addEventListener("click",function(event){
            if(historyBack){
                history.back();
            }else{
                location.href="/";
            }
        });
    }
})();